module.exports = __webpack_public_path__ + "img/no_change.f89307ed.png";